import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiEventManager} from 'ng-jhipster';
import {IActivityType} from '@entities/activity/activity.model';
import {ActivityService} from '@entities/activity/activity.service';

@Component({
  selector: 'app-activity-type-mgmt-delete-dialog',
  templateUrl: './activity-type-delete-dialog.component.html',
})
export class ActivityTypeMgmtDeleteDialogComponent {
  activityType: IActivityType;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }

  constructor(
    private dialogRef: MatDialogRef<ActivityTypeMgmtDeleteDialogComponent>,
    private activityTypeService: ActivityService,
    private eventManager: JhiEventManager,
  ) {}

  confirmDelete(activityTypeId) {
    this.activityTypeService.delete(activityTypeId).subscribe((response) => {
      this.eventManager.broadcast({
        name: 'activityTypeListModification',
        content: 'Deleted a hoạt động',
      });
      this.dialogRef.close(true);
    });
  }
}

@Component({
  selector: 'app-activity-type-mgmt-delete-popup',
  template: '',
})
export class ActivityTypeMgmtDeletePopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<ActivityTypeMgmtDeleteDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityType.delete'),
    );
    this.activatedRoute.data.subscribe(({activityType}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(
          ActivityTypeMgmtDeleteDialogComponent,
          {
            disableClose: true,
            width: '380px',
          },
        );

        this.dialogRef.componentInstance.activityType = activityType;

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityType.list'),
    );
    this.dialogRef = null;
  }
}
